module.exports = __webpack_public_path__ + "static/media/SignInStoneBackground.b4e1de0e.jpeg";